<template>
  <div class="box">
    <Modal v-model="visible" title="文档安全审核" @on-ok="ok" @on-cancel="cancel" width="850" closable>
      <div class="modal-box">
        <div class="head_ctr">
          <div class="item">
            <div class="left">文档安全审核：</div>
            <div class="right">
              <i-switch v-model="agentSwitch" @on-change="agentSwitchChange"></i-switch>
              <a class="tips-text" target="_blank" @click="toGuide">（查看收费标准）</a>
            </div>
            <div class="r-tips">功能打开后，选择的机器将参与打印文件安全审核机制</div>
          </div>
          <div class="item" v-if="agentSwitch">
            <div class="left">余额不足继续打印：</div>
            <div class="right">
              <i-switch v-model="noMoneySwitch" @on-change="noMoneyChange"></i-switch>
            </div>
            <div class="r-tips">功能打开后，当钱包余额不足时，将跳过审核机制</div>
          </div>
        </div>

        <div class="tableTitle" v-if="agentSwitch">选择设备：</div>

        <Table :columns="columns" :data="data" ref="selection" @on-selection-change="selectTable" height="300"
          size="small" v-if="agentSwitch">
          <template slot-scope="{ row }" slot="status">
            <span>{{ status[row.status].name }}</span>
          </template>
        </Table>
        <div class="t-right" style="margin-top: 20px" v-if="agentSwitch">
          <Page @on-change="pageChange" @on-page-size-change="sizeChange" :current="page.p + 1" :total="total"
            :page-size="10" show-elevator show-sizer show-total />
        </div>
      </div>
      <div slot="footer" style="margin: 0 30px; text-align: right">
        <Button @click="cancel">取消</Button>
        <Button type="primary" @click="doSubmit" style="margin-left: 10px">确定</Button>
      </div>
    </Modal>

    <!-- 充值弹窗 -->
    <Modal v-model="rechargeModal.visible" title="账户充值" width="500">
      <Form :label-width="80" class="pay_content">
        <FormItem label="充值金额">
          <InputNumber :min="0.01" :precision="2" v-model="rechargeModal.money" placeholder="请输入充值金额"
            style="width: 100%" />
        </FormItem>

        <FormItem label="快捷选择">
          <div class="amount-buttons">
            <Button v-for="amount in [100, 300, 500, 800, 1000]" :key="amount"
              :type="rechargeModal.money === amount ? 'primary' : 'default'" @click="rechargeModal.money = amount"
              style="margin-right: 10px; margin-bottom: 10px">
              {{ amount }}元
            </Button>
          </div>
        </FormItem>

        <FormItem label="支付方式">
          <div class="payment-buttons">
            <RadioGroup style="margin-top: 10px; padding-left: 10px; display: flex" v-model="rechargeModal.pay_type">
              <!-- <Radio :label="1" style="margin-right: 60px" class="radio">
            <img class="pay_icon" src="../../assets/images/ic_pay2.png" />
          </Radio> -->
              <Radio :label="2" style="margin-right: 60px" class="radio">
                <img style="width: 26px" src="../../../assets/images/ic_alipay.png" />支付宝支付
              </Radio>
              <!-- <Radio :label="3" class="radio">
                <img class="pay_icon" src="../../../assets/images/ic_pay1.png" />
              </Radio> -->
            </RadioGroup>
          </div>
        </FormItem>

      </Form>
      <div slot="footer">
        <Button @click="rechargeModal.visible = false">取消</Button>
        <Button type="primary" :loading="rechargeModal.loading" @click="doRecharge">去支付</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    showOpenFileCheckModal: {
      default: false
    }
  },
  data () {
    return {
      visible: true,
      agentSwitch: true,
      page: {
        l: 10,
        p: 0,
        meter: '0,3',
        agent_id: 0,
        key: ''
      },
      total: 0,
      data: [],
      allData: [],
      selectData: {},
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '设备ID',
          width: 80,
          key: 'mark',
          fixed: 'left'
        },
        {
          title: '序列号',
          width: 120,
          key: 'sn',
          fixed: 'left'
        },
        {
          title: '设备型号',
          width: 120,
          key: 'machine_type_name'
        },
        {
          title: '设备站点',
          key: 'site_name',
          width: 200
        },
        {
          title: '地址',
          key: 'address',
          width: 200
        }
      ],
      rechargeModal: {
        visible: false,
        money: 0,
        loading: false,
        pay_type: 2
      }
    }
  },
  created () {
    if (this.agent.tp === 0) {
      this.columns.splice(3, 0, {
        title: '所属',
        key: 'agent_name',
        width: 220
      })
    }
    this.agentFuncShows()
    // 获取列表
    this.getMachine()
  },
  methods: {
    ...mapActions(['MachineListConcise', 'SaveAgentFunc', 'getUserInfo', 'AgentIncrementRecharge', 'SaveMachineFuncs', 'SaveAgentNoMoneyPrint']),
    agentFuncShows () {
      // 开关
      console.log('funcs', this.agent.func)
      const funcs = this.agent.functions ? this.agent.functions.split(',') : []
      if (funcs.includes('fileCheck')) {
        this.agentSwitch = true
      } else {
        this.agentSwitch = false
      }
      if (!this.agent.no_money_print) {
        this.noMoneySwitch = true
      } else {
        this.noMoneySwitch = false
      }
    },
    async getMachine () {
      const { total, data } = await this.MachineListConcise(this.page)
      this.total = total
      if (!this.selectData[this.page.p]) this.selectData[this.page.p] = []
      data.map((item) => {
        // 检查allData中是否已存在相同id的数据项
        const existingItem = this.allData.find(existing => existing.id === item.id)
        if (!existingItem) {
          this.allData.push(item)
        }

        if (this.selectData[this.page.p]) {
          this.selectData[this.page.p].map((val) => {
            if (item.id === val.id) item._checked = true
          })
        }
        if (item.functions.indexOf('fileCheck') !== -1) {
          item._checked = true
        }
      })
      this.data = data
    },
    ok () { },
    cancel () {
      this.$emit('cancel')
    },
    selectTable (e) {
      this.selectData[this.page.p] = e
      // 更新allData中的设备选择状态
      this.data.forEach(item => {
        const isSelected = e.some(selected => selected.id === item.id)
        const hasFileCheck = item.functions.indexOf('fileCheck') !== -1

        // 找到对应的allData项
        const allDataItem = this.allData.find(dataItem => dataItem.id === item.id)
        if (allDataItem) {
          if (hasFileCheck && !isSelected) {
            // 设备原本有fileCheck功能但现在被取消选择
            allDataItem._manualUncheck = true
          } else if (isSelected) {
            // 设备被选中，无论之前状态如何，都清除_manualUncheck标记
            allDataItem._manualUncheck = false
          }
        }
      })
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getMachine()
    },
    sizeChange (l) {
      this.page.l = l
      this.getMachine()
    },
    async agentSwitchChange (e) {
      let funcs = this.agent.functions ? this.agent.functions.split(',') : []
      if (e && !funcs.includes('fileCheck')) {
        console.log('includes')
        funcs.push('fileCheck')
      }
      if (!e && funcs.includes('fileCheck')) {
        console.log('cancel')
        for (let index = 0; index < funcs.length; index++) {
          const element = funcs[index]
          if (element === 'fileCheck') {
            funcs.splice(index, 1)
          }
        }
      }
      this.$Spin.show()
      const res = await this.SaveAgentFunc({ func: funcs.join(',') })
      if (!res.status) {
        this.$Message.error('请重试')
        this.agentSwitch = !e
        this.agentFuncShows()
        return
      }
      await this.getUserInfo()
      this.agentFuncShows()
      this.$Spin.hide()
    },

    async noMoneyChange (e) {
      console.log('e', e)
      this.$Spin.show()
      /*   let no_money_print = 0;
        if(e){
          no_money_print = 1;
        } */
      const res = await this.SaveAgentNoMoneyPrint({ no_money_print: e ? 0 : 1 })
      this.$Spin.hide()
      if (!res.status) {
        this.$Message.error('请重试')
        this.noMoneySwitch = !e
        this.agentFuncShows()
        return
      }
      await this.getUserInfo()
      this.agentFuncShows()
    },
    // 显示充值弹窗
    showRechargeModal () {
      this.rechargeModal.visible = true
      this.rechargeModal.money = 0
    },
    // 执行充值
    async doRecharge () {
      if (this.rechargeModal.money <= 0) {
        this.$Message.error('充值金额有误')
        return
      }
      if (this.rechargeModal.money <= 1) {
        this.$Message.error('最低充值1元')
        return
      }
      this.rechargeModal.loading = true
      try {
        const res = await this.AgentIncrementRecharge({
          money: this.rechargeModal.money,
          pay_type: 2
        })
        if (res) {
          this.rechargeModal.visible = false
          window.open(`https://openapi.alipay.com/gateway.do?${res}`)
        } else {
          this.$Message.error('充值失败')
        }
      } catch (error) {
        this.$Message.error('充值失败')
      }
      this.rechargeModal.loading = false
    },
    async UpdateAgentInfo () {
      await this.getUserInfo()
    },
    async doSubmit () {
      this.$Spin.show()
      // 创建一个新的数组来存储所有需要更新的数据
      const selectedList = []

      // 遍历allData，只处理被修改过的设备
      this.allData.forEach(item => {
        const isSelected = Object.values(this.selectData).some(pageData =>
          Array.isArray(pageData) && pageData.some(selected => selected.id === item.id)
        )

        // 只处理以下情况的设备：
        // 1. 原本有fileCheck功能但被手动取消选择
        // 2. 原本没有fileCheck功能但被新选中
        const hasFileCheck = item.functions.indexOf('fileCheck') !== -1

        if ((hasFileCheck && item._manualUncheck) || (!hasFileCheck && isSelected)) {
          // 创建functions的副本，以便进行修改
          let functions = item.functions ? item.functions.split(',') : []

          if (isSelected && !hasFileCheck) {
            // 新选中的设备，添加fileCheck功能
            functions.push('fileCheck')
          } else if (item._manualUncheck && hasFileCheck) {
            // 手动取消选择的设备，移除fileCheck功能
            functions = functions.filter(func => func !== 'fileCheck')
          }

          selectedList.push({
            id: item.id,
            _checked: isSelected && !item._manualUncheck,
            functions: functions.join(',')
          })
        }
      })

      console.log('需要更新的设备列表：', selectedList)
      if (!selectedList.length) {
        this.$Spin.hide()
        this.cancel()
        return
      }
      const res = await this.SaveMachineFuncs({ list: selectedList })
      this.$Message[res.status ? 'success' : 'error'](res.msg)
      if (!res.status) {
        this.$Spin.hide()
        return
      }
      this.data = []
      this.allData = []
      this.selectData = {}
      await this.getMachine()
      this.$Spin.hide()
      this.$emit('cancel')
    },
    toGuide () {
      const routerUrl = this.$router.resolve({ path: '/increments/guide' })
      window.open(routerUrl.href, '_blank')
    }
  },
  computed: mapGetters({
    agent: 'agent'
  }),
  watch: {}
}
</script>
<style lang="less" scoped>
@import "../index.less";

.box {
  position: fixed;
}
.tips-text{
  color: #2D8CF0;
  font-size: 14px;
  margin-left: 10px;
  cursor: pointer;
  font-weight: bold;
}
.modal-box {
  padding: 10px 20px 20px 20px;

  .tableTitle {
    font-size: 18px;
    color: #000;
    font-weight: bold;
  }

  .item {
    display: flex;
    height: 70px;
    flex-wrap: wrap;

    .left {
      font-size: 18px;
      color: #000;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .right {
      flex: 1;
      display: flex;
      line-height: 25px;
      flex-wrap: wrap;
    }

    .r-tips {
      font-size: 12px;
      color: #aaa;
      width: 100%;
      margin-top: -20px;
    }
  }
}

.amount-buttons {
  margin-bottom: 15px;
}

.head_ctr {
  display: flex;
}
</style>
